module.exports = {
  ROOT_PATH: '/',
  SERVICE_PORTAL_PATH: '/servicePortal',
  INCIDENT_PATH: '/submitIncident',
  SR_PATH: '/submitSR',
  ACTION_PATH_PARAMS: '/ActionEdit/:id',
  ACTION_PATH: '/ActionEdit',
  SCOREBOARD_PATH: '/scoreboard',
  // FAQ_PATH: '/faq',
  // FAQ_PATH_PARAM: '/faq/:id',
  MY_SETTINGS_PATH: '/mySettings',
  SR_VIEW: '/SRview',
  SR_VIEW_PARAM: '/SRview/:id',
  MY_DESKTOP_PATH: '/myDesktop',
  PASSWORD_SERVICES_PATH: '/passwordServices',
  CALENDAR_PATH: '/calendar',
  REDIRECT_COMP: '/redirect/:to',
  SEARCH_RESULT: '/search',
  HOME: '/home',
  SERVICE_CATALOG_PATH: '/serviceCatalog',
  SERVICE_CATALOG_PATH_PARAM: '/serviceCatalog/:id'
};



// WEBPACK FOOTER //
// ./constants/routes.js